import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSector = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 13 12",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12.0009 6.09993V10.4899C12.0009 10.7999 11.8209 10.9999 11.7009 10.9999H8.74094L7.71094 8.40993L11.9909 6.10993M13.0009 4.42993L6.46094 7.94993L8.07094 11.9999H11.7009C12.4209 11.9999 13.0009 11.3199 13.0009 10.4899V4.42993Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M1.3 1L5.26 11H1.3C1.18 11 1 10.8 1 10.49V1.51C1 1.2 1.18 1 1.3 1ZM1.98 0H1.3C0.58 0 0 0.68 0 1.51V10.49C0 11.32 0.58 12 1.3 12H6.74L1.98 0Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M11.6986 1C11.8186 1 11.9986 1.2 11.9986 1.51V2.19L6.43859 5.18L4.77859 1H11.6986ZM11.6986 0H3.30859L5.91859 6.6L12.9886 2.79V1.51C12.9886 0.68 12.4086 0 11.6886 0L11.6986 0Z" })
	]
});
export default SvgSector;
